export default __webpack_public_path__ + "static/media/payment-paybyme.eff67a91.svg";